import {Formik, Field, Form, ErrorMessage} from 'formik';
import React from 'react';
import * as Yup from 'yup';
import _ from 'lodash';
import {Modal} from '../../shared/modal/Modal';
import {Btn, CancelBtn} from '../../shared/elements/btn/Btn.js';
import {FormInput} from '../../shared/form/form-control/FormInput.js';
import {Row} from '../../shared/grid/grid-features/Row.js';
import {Col} from '../../shared/grid/grid-features/Col.js';

import {ValidationErrorTxt} from '../../shared/form/form-features/ValidationErrorTxt';
import {withTranslation} from 'react-i18next';
import {FormGroup} from '../../shared/form/form-features/FormGroup.js';
import {FormSelectContainer} from '../../shared/form/form-control/FormSelect.js';
import {Icon} from '../../shared/elements/icon/Icon.js';
import {USER_ROLES} from './UserOverview.jsx';

function UserAddModal({cancel, save, t}) {
    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required(t('errors.RequiredField')),
        lastName: Yup.string().required(t('errors.RequiredField')),
        role: Yup.string().required(t('errors.RequiredField')).oneOf(USER_ROLES),
        email: Yup.string().email(t('errors.InvalidEmail')).required(t('errors.RequiredField')),
    });

    return (
        <div>
            <Formik
                onSubmit={save}
                validationSchema={validationSchema}
                initialValues={{firstName: '', lastName: '', email: '', role: ''}}
            >
                {({isSubmitting, handleSubmit}) => (
                    <Form>
                        <Modal title={t('user.AddUser')}>
                            <Modal.Body>
                                <FormGroup>
                                    <FormSelectContainer>
                                        <Icon icon="ArrowDropDown" />
                                        <Field size="sm" name="role" as="select">
                                            <option key={0} value={0}>
                                                {t('SelectRole')}
                                            </option>
                                            {_.map(USER_ROLES, (role, i) => (
                                                <option key={i} value={role}>
                                                    {t(`roles.${role}`)}
                                                </option>
                                            ))}
                                        </Field>
                                    </FormSelectContainer>
                                    <ErrorMessage name="role">
                                        {(msg) => <ValidationErrorTxt>{msg}</ValidationErrorTxt>}
                                    </ErrorMessage>
                                </FormGroup>

                                <Row>
                                    <Col colsize="50">
                                        <FormInput name="firstName" placeholder={t('user.FirstName')} />
                                    </Col>
                                    <Col colsize="50">
                                        <FormInput name="lastName" placeholder={t('user.LastName')} />
                                    </Col>
                                </Row>
                                <FormInput name="email" placeholder={t('user.Email')} />
                            </Modal.Body>
                            <Modal.Footer>
                                <CancelBtn type="button" color="default" onClick={cancel} disabled={isSubmitting}>
                                    {t('general.Cancel')}
                                </CancelBtn>
                                <Btn onClick={handleSubmit} color="success" disabled={isSubmitting}>
                                    {t('general.Submit')}
                                </Btn>
                            </Modal.Footer>
                        </Modal>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default withTranslation()(UserAddModal);
